import { render, staticRenderFns } from "./ConversationChat.vue?vue&type=template&id=7227f5c2&scoped=true&"
import script from "./ConversationChat.vue?vue&type=script&lang=js&"
export * from "./ConversationChat.vue?vue&type=script&lang=js&"
import style0 from "./ConversationChat.vue?vue&type=style&index=0&id=7227f5c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7227f5c2",
  null
  
)

export default component.exports